// ── Keuzehulp-configuratie ───────────────────────────────────────────────────
// Config-gestuurde keuzehulp. Elke topic heeft vragen; elk antwoord kent punten
// toe aan één of meer echte WooCommerce-categorie-slugs. Aan het eind wint de
// categorie met de meeste punten → die tonen we met passende producten.
//
// Nieuwe keuzehulp toevoegen? Voeg een topic toe met `slug`, `questions` en
// `results`. De slugs in `points`/`results` moeten bestaande categorie-slugs zijn.

export const KEUZEHULP_TOPICS = [
  {
    slug: 'zonnepanelen',
    title: 'Zonnepanelen-keuzehulp',
    tagline: 'In 2 vragen naar de panelen die bij jouw situatie passen',
    icon: 'bi-sun',
    image: '/wp-content/uploads/2026/07/balkonpanelen_met_batterij.png',
    questions: [
      {
        q: 'Waar wil je de zonnepanelen plaatsen?',
        options: [
          { label: 'Aan mijn balkon of gevel', icon: 'bi-building', points: { 'balkon-zonnepanelen': 3 } },
          { label: 'Op een plat dak of in de tuin', icon: 'bi-house', points: { 'zonnepanelen-sets': 3 } },
          { label: 'Ik heb al een systeem', icon: 'bi-plus-square', points: { 'losse-zonnepanelen': 3 } },
        ],
      },
      {
        q: 'Wat zoek je precies?',
        options: [
          { label: 'Een compleet plug & play pakket', icon: 'bi-box-seam', points: { 'zonnepanelen-sets': 2, 'balkon-zonnepanelen': 1 } },
          { label: 'Panelen mét opslag (batterij)', icon: 'bi-battery-charging', points: { 'balkon-zonnepanelen': 2, 'zonnepanelen-sets': 1 } },
          { label: 'Alleen losse panelen', icon: 'bi-grid', points: { 'losse-zonnepanelen': 2 } },
        ],
      },
    ],
    results: {
      'balkon-zonnepanelen': { name: 'Balkon zonnepanelen', sub: 'Plug & play - ideaal voor huurders en appartementen, zonder vergunning.' },
      'zonnepanelen-sets':   { name: 'Complete zonnepanelen-sets', sub: 'Alles-in-één pakketten voor je dak of tuin, klaar om te installeren.' },
      'losse-zonnepanelen':  { name: 'Losse zonnepanelen', sub: 'Los bij te bestellen panelen om je bestaande systeem uit te breiden.' },
    },
  },

  {
    slug: 'laadpaal',
    title: 'Laadpaal-keuzehulp',
    tagline: 'Vind de laadoplossing die past bij jouw situatie',
    icon: 'bi-ev-station',
    image: '/wp-content/uploads/2026/07/Gemini_Generated_Image_j8cvjcj8cvjcj8cv.png',
    questions: [
      {
        q: 'Waar ga je laden?',
        options: [
          { label: 'Thuis, bij mijn eigen woning', icon: 'bi-house-door', points: { 'thuislaadpalen': 3, 'slimme-laadpalen': 1 } },
          { label: 'Bij een bedrijf of openbaar', icon: 'bi-building', points: { 'zakelijke-laadpalen': 3 } },
        ],
      },
      {
        q: 'Wil je slim laden (met zonne-overschot en app)?',
        options: [
          { label: 'Ja, zo slim mogelijk', icon: 'bi-lightning-charge', points: { 'slimme-laadpalen': 3 } },
          { label: 'Gewoon betrouwbaar laden', icon: 'bi-plug', points: { 'thuislaadpalen': 2 } },
        ],
      },
      {
        q: 'Heb je een 3-fase aansluiting (krachtstroom)?',
        options: [
          { label: 'Ja, 3-fase', icon: 'bi-diagram-3', points: { '3-fase-laadpalen': 3 } },
          { label: 'Nee / weet ik niet', icon: 'bi-question-circle', points: { 'thuislaadpalen': 1, 'slimme-laadpalen': 1 } },
        ],
      },
    ],
    results: {
      'thuislaadpalen':   { name: 'Thuislaadpalen', sub: 'Betrouwbare laadpalen voor thuis, eenvoudig te installeren.' },
      'slimme-laadpalen': { name: 'Slimme laadpalen', sub: 'Laad op je eigen zonne-energie en stuur alles via een app.' },
      '3-fase-laadpalen': { name: '3-fase laadpalen', sub: 'Maximaal laadvermogen met een krachtstroom-aansluiting.' },
      'zakelijke-laadpalen': { name: 'Zakelijke laadpalen', sub: 'Robuuste oplossingen voor bedrijf, personeel en openbaar gebruik.' },
    },
  },

  {
    slug: 'thuisbatterij',
    title: 'Thuisbatterij-keuzehulp',
    tagline: 'Ontdek welke opslag bij jouw verbruik past',
    icon: 'bi-battery-charging',
    image: '/wp-content/uploads/2026/07/thomas_batterij-removebg-preview.png',
    questions: [
      {
        q: 'Waarvoor wil je energie opslaan?',
        options: [
          { label: 'Onderweg, camping of als noodstroom', icon: 'bi-brightness-high', points: { 'draagbare-batterijen': 3 } },
          { label: 'Stekkerklaar bij mijn balkon/tuin', icon: 'bi-plug', points: { 'stekkerbatterij': 3 } },
          { label: 'Een vast systeem voor mijn hele huis', icon: 'bi-house-gear', points: { 'thuisbatterijen': 2, 'all-in-one-batterijen': 1 } },
        ],
      },
      {
        q: 'Hoe groot is je jaarverbruik ongeveer?',
        options: [
          { label: 'Klein (< 3.000 kWh)', icon: 'bi-bar-chart', points: { 'stekkerbatterij': 1, 'draagbare-batterijen': 1 } },
          { label: 'Gemiddeld (3.000–5.000 kWh)', icon: 'bi-bar-chart-line', points: { 'thuisbatterijen': 2 } },
          { label: 'Groot (> 5.000 kWh)', icon: 'bi-graph-up-arrow', points: { 'thuisbatterijen': 2, 'all-in-one-batterijen': 2 } },
        ],
      },
    ],
    results: {
      'draagbare-batterijen': { name: 'Draagbare batterijen', sub: 'Compacte powerstations voor onderweg, camping of noodstroom.' },
      'stekkerbatterij':      { name: 'Stekkerbatterijen', sub: 'Plug & play thuisopslag - zo in het stopcontact, geen installateur nodig.' },
      'thuisbatterijen':      { name: 'Thuisbatterijen', sub: 'Vaste opslag voor je hele huis: gebruik je zonnestroom ook ’s avonds.' },
      'all-in-one-batterijen':{ name: 'All-in-one batterijen', sub: 'Omvormer en opslag gecombineerd in één krachtig systeem.' },
    },
  },
]

export function getKeuzehulpTopic(slug) {
  return KEUZEHULP_TOPICS.find(t => t.slug === slug) || null
}
